var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-alert',{attrs:{"variant":"info","show":""}},[(_vm.enable_raw_html == 'true')?_c('span',{domProps:{"innerHTML":_vm._s(_vm.baustein.label)}}):_c('span',[_vm._v("\n            "+_vm._s(_vm.baustein.label)+"\n            ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }